<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4"></div>
      <div class="col-lg-4">
        <Login></Login>
      </div>
      <div class="col-lg-4"></div>
    </div>
  </div>

</template>

<script>
import Login from "@/components/Login";

export default {
  components: { Login }
}
</script>